// @flow
import {
  UPDATE_SOCIAL_HISTORY_LOADING,
  UPDATE_SOCIAL_HISTORY_SUCCESS,
  UPDATE_SOCIAL_HISTORY_ERROR,
  UPDATE_GENERAL_INFO_LOADING,
  UPDATE_GENERAL_INFO_SUCCESS,
  UPDATE_GENERAL_INFO_ERROR,
  ADD_HOUSE_HISTORY_LOADING,
  ADD_HOUSE_HISTORY_SUCCESS,
  ADD_HOUSE_HISTORY_ERROR,
  UPDATE_HOUSE_HISTORY_LOADING,
  UPDATE_HOUSE_HISTORY_SUCCESS,
  UPDATE_HOUSE_HISTORY_ERROR,
  DELETE_HOUSE_HISTORY_LOADING,
  DELETE_HOUSE_HISTORY_SUCCESS,
  DELETE_HOUSE_HISTORY_ERROR,
  ADD_HOSPITALIZATION_HISTORY_LOADING,
  ADD_HOSPITALIZATION_HISTORY_SUCCESS,
  ADD_HOSPITALIZATION_HISTORY_ERROR,
  UPDATE_HOSPITALIZATION_HISTORY_LOADING,
  UPDATE_HOSPITALIZATION_HISTORY_SUCCESS,
  UPDATE_HOSPITALIZATION_HISTORY_ERROR,
  DELETE_HOSPITALIZATION_HISTORY_LOADING,
  DELETE_HOSPITALIZATION_HISTORY_SUCCESS,
  DELETE_HOSPITALIZATION_HISTORY_ERROR,
  ADD_SIGNIFICANT_HISTORY_LOADING,
  ADD_SIGNIFICANT_HISTORY_SUCCESS,
  ADD_SIGNIFICANT_HISTORY_ERROR,
  UPDATE_SIGNIFICANT_HISTORY_LOADING,
  UPDATE_SIGNIFICANT_HISTORY_SUCCESS,
  UPDATE_SIGNIFICANT_HISTORY_ERROR,
  DELETE_SIGNIFICANT_HISTORY_LOADING,
  DELETE_SIGNIFICANT_HISTORY_SUCCESS,
  DELETE_SIGNIFICANT_HISTORY_ERROR,
  ADD_DIET_HISTORY_LOADING,
  ADD_DIET_HISTORY_SUCCESS,
  ADD_DIET_HISTORY_ERROR,
  UPDATE_DIET_HISTORY_LOADING,
  UPDATE_DIET_HISTORY_SUCCESS,
  UPDATE_DIET_HISTORY_ERROR,
  DELETE_DIET_HISTORY_LOADING,
  DELETE_DIET_HISTORY_SUCCESS,
  DELETE_DIET_HISTORY_ERROR,
} from '../actions/informationHistoryActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case UPDATE_SOCIAL_HISTORY_LOADING:
    case UPDATE_GENERAL_INFO_LOADING:
    case ADD_HOUSE_HISTORY_LOADING:
    case UPDATE_HOUSE_HISTORY_LOADING:
    case DELETE_HOUSE_HISTORY_LOADING:
    case ADD_HOSPITALIZATION_HISTORY_LOADING:
    case UPDATE_HOSPITALIZATION_HISTORY_LOADING:
    case DELETE_HOSPITALIZATION_HISTORY_LOADING:
    case ADD_SIGNIFICANT_HISTORY_LOADING:
    case UPDATE_SIGNIFICANT_HISTORY_LOADING:
    case DELETE_SIGNIFICANT_HISTORY_LOADING:
    case ADD_DIET_HISTORY_LOADING:
    case UPDATE_DIET_HISTORY_LOADING:
    case DELETE_DIET_HISTORY_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case UPDATE_SOCIAL_HISTORY_SUCCESS:
    case UPDATE_GENERAL_INFO_SUCCESS:
    case ADD_HOUSE_HISTORY_SUCCESS:
    case UPDATE_HOUSE_HISTORY_SUCCESS:
    case DELETE_HOUSE_HISTORY_SUCCESS:
    case ADD_HOSPITALIZATION_HISTORY_SUCCESS:
    case UPDATE_HOSPITALIZATION_HISTORY_SUCCESS:
    case DELETE_HOSPITALIZATION_HISTORY_SUCCESS:
    case ADD_SIGNIFICANT_HISTORY_SUCCESS:
    case UPDATE_SIGNIFICANT_HISTORY_SUCCESS:
    case DELETE_SIGNIFICANT_HISTORY_SUCCESS:
    case ADD_DIET_HISTORY_SUCCESS:
    case UPDATE_DIET_HISTORY_SUCCESS:
    case DELETE_DIET_HISTORY_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case UPDATE_SOCIAL_HISTORY_ERROR:
    case UPDATE_GENERAL_INFO_ERROR:
    case ADD_HOUSE_HISTORY_ERROR:
    case UPDATE_HOUSE_HISTORY_ERROR:
    case DELETE_HOUSE_HISTORY_ERROR:
    case ADD_HOSPITALIZATION_HISTORY_ERROR:
    case UPDATE_HOSPITALIZATION_HISTORY_ERROR:
    case DELETE_HOSPITALIZATION_HISTORY_ERROR:
    case ADD_SIGNIFICANT_HISTORY_ERROR:
    case UPDATE_SIGNIFICANT_HISTORY_ERROR:
    case DELETE_SIGNIFICANT_HISTORY_ERROR:
    case ADD_DIET_HISTORY_ERROR:
    case UPDATE_DIET_HISTORY_ERROR:
    case DELETE_DIET_HISTORY_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
        type: action.type,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/informationHistoryReducer.js